import { TableTransferList } from "./components/Tables/TransferList"

export default function TransferList() {
  return (
    <section className="container my-5 flex flex-col gap-5">
      <TableTransferList />
    </section>
  )
}
